
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import RoleAccessSection from '@/components/RoleAccessSection.vue'
import { masterDataFactory } from '@/http/master-data'
import { cheatDataFactory } from '@/http/cheat-data'
import LocalStorage from '@/utils/localstorage'
import Swal from 'sweetalert2'
import roleAccessManager from '@/utils/role-access-manager'

export default defineComponent({
  components: {
    Header,
    RoleAccessSection
  },
  data() {
    return {
      configs: [],
      counter: 0,
      cheatMode: false,
      canCreate: false,
      canRead: false,
      canUpdate: false,
      canDelete: false
    }
  },
  computed: {
    isRoleAccessEnabled(): boolean {
      // Check if configs is an object
      if (typeof this.configs !== 'object' || this.configs === null) {
        return false
      }
      
      // Safely access spp_activate_role_access using optional chaining
      const roleAccessConfig = this.configs?.spp_activate_role_access
      
      // Check if config exists and has the expected value
      if (!roleAccessConfig || !roleAccessConfig.conf_value) {
        return false
      }
      
      return roleAccessConfig.conf_value === 'true' || roleAccessConfig.conf_value === true
    }
  },
  async mounted() {
    // Check read access to /configs
    if (!roleAccessManager.canRead('/configs')) {
      Swal.fire('Error', 'Anda tidak memiliki akses ke halaman ini', 'error')
        .then(() => {
          this.$router.push('/loginpage')
        })
      return
    }

    // Set permission flags
    this.canCreate = roleAccessManager.canCreate('/configs')
    this.canRead = roleAccessManager.canRead('/configs')
    this.canUpdate = roleAccessManager.canUpdate('/configs')
    this.canDelete = roleAccessManager.canDelete('/configs')

    this.loadConfigs()
    this.checkCheatMode()
  },
  watch: {
    configs: {
      handler: function (val: any) {
        if (this.counter > 0) {
          Promise.resolve(masterDataFactory.setConfigs({ configs: val })).then(
            (res: any) => {
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Configs updated'
              })
            }
          )
        }
        this.counter++
      },
      deep: true
    }
  },
  methods: {
    async loadConfigs() {
      try {
        const response: any = await masterDataFactory.getConfigs()
        this.configs = response.data.configs
      } catch (error) {
        console.error('Error loading configs:', error)
      }
    },
    checkCheatMode() {
      const cheatToken = LocalStorage.getOne('cheatToken') || ''
      if (cheatToken != '') {
        Promise.resolve(cheatDataFactory.validateCheatToken({ token: cheatToken })).then(
          (res: any) => {
            this.cheatMode = res.data
            if (!this.cheatMode) {
              LocalStorage.remove('cheatToken')
            }
          }
        )
      } else {
        if (!this.cheatMode) {
          LocalStorage.remove('cheatToken')
        }
      }
    },
    activateCheatMode() {
      if (this.cheatMode) {
        Swal.fire({
          title: 'Enter Master Password',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Activate',
          showLoaderOnConfirm: true,
          preConfirm: (mpwd: any) => {
            return cheatDataFactory.activateCheatMode({ mpwd: mpwd }).then(
              (res: any) => {
                if (res.data) {
                  LocalStorage.set('cheatToken', res.data)
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Cheat Mode Activated, redirecting to cheats in 3 seconds'
                  })
                  setTimeout(() => {
                    location.href = '/cheats'
                  }, 3000)
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: res.messages + ', reload in 3 seconds'
                  })
                  setTimeout(() => {
                    location.reload()
                  }, 3000)
                }
              }
            )
          },
          allowOutsideClick: false,
          didClose: () => {
            location.reload()
          }
        })
      } else {
        LocalStorage.remove('cheatToken')
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Cheat Mode Deactivated, reload in 3 seconds'
        })
        setTimeout(() => {
          location.reload()
        }, 3000)
      }
    }
  }
})
